/* eslint-disable max-lines */
import React, { forwardRef, useImperativeHandle, useState, useEffect, useMemo, useRef } from 'react'
import { connect } from 'dva'
import { Form, Space, Row, Col, Button, message as $message, Tooltip, Popconfirm } from 'antd'
import DownOutlined from '@ant-design/icons/DownOutlined'
import UpOutlined from '@ant-design/icons/UpOutlined'
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled'
import styled from 'styled-components'
import SortQuickSearch from '@/modules/globals/components/QueryFilter/components/SortQuickSearch'
import { jstLogSearch } from '@/utils/logger'
import { createAPI } from '@/utils/modal'
import QuickSearchModal from './components/QuickSearchModal'
import isEmpty from 'lodash/isEmpty'
import useWindowSize from '@/hooks/useWindowSize'
import classNames from 'classnames'
import debounce from 'lodash/debounce'

import styles from './index.less'

import { storage } from '@/hooks/useIknow'

// import QuickSearchFilterList from './components/QuickSearchFilterList'
/**
 *  showScan: 是否需要下拉展开
 *  showCol: 是否对齐显示
 *  verticalSize: normal large(可以添加表单rules)
 *  disabled: 禁用按钮
 *  num:  4(一行显示4)  8(一行显示8)  屏幕最大的时候   1(一行显示一个)
 *  fontSize: 14px, 字体大小 这里主要因为订单页要12px
 */

const maxQuickFilterLength = 10
const debounceTimer = 300

const isEmptyObj = obj => {
    const objValues = Object.values(obj)
    for (let i = 0; i < objValues.length; i++) {
        const element = objValues[i]

        if (!isEmpty(element)) {
            // 订单状态要特殊处理
            if (element.orderStatus || element.questionTypes) {
                if (element.orderStatus?.length > 0 || element?.questionTypes?.length > 0) {
                    return false
                } else {
                    continue
                }
            }

            // 有数据 但是是leftValue rightValue的形式
            if (element?.leftValue) {
                if (element?.rightValue) {
                    return false
                } else {
                    continue
                }
            }

            return false
        }
    }
    return true
}

const filterItemLayout = {
    1: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 },
        lg: { span: 24 },
        xl: { span: 24 }
    },
    2: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 12 },
        lg: { span: 12 },
        xl: { span: 12 },
        xxl: { span: 6 }
    },
    3: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 12 },
        lg: { span: 8 },
        xl: { span: 8 }
    },
    4: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 12 },
        lg: { span: 8 },
        xl: { span: 6 }
    },
    6: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 12 },
        lg: { span: 4 },
        xl: { span: 4 }
    },
    8: {
        xs: { span: 12 },
        sm: { span: 12 },
        md: { span: 6 },
        lg: { span: 4 },
        xl: { span: 3 }
    },
    12: {
        xs: { span: 12 },
        sm: { span: 12 },
        md: { span: 6 },
        lg: { span: 3 },
        xl: { span: 2 }
    }
}

const ItemComponent = ({ item, form, initialValues, ...restProps }) => {
    const tips = typeof item.renderTips === 'function' ? item.renderTips({ form, initialValues }) : item.tips
    const tipsTrigger = item.tipsTrigger || 'hover'

    return (
        <Tooltip
            overlay={null}
            title={tips}
            trigger={tipsTrigger}
            overlayStyle={{ maxWidth: '225px', fontSize: '12px' }}
            color="rgba(0,0,0,0.7)"
        >
            <item.component
                form={form}
                name={item.name}
                {...restProps}
                {...item.props}
                {...(typeof item.renderProps === 'function' ? item.renderProps({ form, initialValues }) : {})}
                className={classNames(styles.item)}
            />
        </Tooltip>
    )
}

const StyledQueryFilter = styled.div`
    .ant-input,
    .ant-select,
    .ant-picker,
    .ant-form label,
    .ant-picker-input > input {
        font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
    }

    .ant-input-sm,
    .ant-picker-small {
        min-height: ${props => (props.fontSize === '12px' ? '24px' : 0)};
    }
    .ant-input-affix-wrapper-sm .ant-input-sm {
        min-height: 0;
    }
    .ant-select-multiple.ant-select-sm .ant-select-selection-search {
        height: 16px;
        line-height: 16px;
    }
    .ant-select-multiple.ant-select-sm .ant-select-selection-search .ant-select-selection-search-input {
        margin-left: -3px;
    }
    .ant-tooltip {
        font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
    }
    .ant-btn.ant-btn-sm {
        font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
    }
    .ant-form {
        font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
    }
`

// eslint-disable-next-line no-unused-vars
const renderFields = ({ fields, name, num, form, initialValues, showCol, storagekeyPrefix, resetFilterItemLayout }) => {
    return (
        <Row gutter={8}>
            {fields.map(item => {
                let itemLayout = {}
                if (showCol) {
                    itemLayout = resetFilterItemLayout[item.num || num]
                }
                let shouldUpdate = item.options && item.options.shouldUpdate
                if (shouldUpdate === true) {
                    shouldUpdate = () => true
                }
                if (!shouldUpdate) {
                    shouldUpdate = () => false
                }

                return (
                    <Form.Item key={item.name} shouldUpdate={shouldUpdate} noStyle>
                        {() => {
                            if (
                                typeof item.shouldRender === 'function' &&
                                !item.shouldRender({ form, initialValues })
                            ) {
                                return null
                            }

                            return (
                                <Col key={item.name} style={item.style} {...itemLayout}>
                                    <Form.Item
                                        name={item.name}
                                        {...item.options}
                                        style={{
                                            display: item.props && item.props.type === 'hidden' && 'none'
                                        }}
                                    >
                                        {item.tips || item.renderTips ? (
                                            <ItemComponent item={item} form={form} initialValues={initialValues} />
                                        ) : (
                                            <item.component
                                                form={form}
                                                name={item.name}
                                                storagekey={`${storagekeyPrefix}_${item.name}`}
                                                {...item.props}
                                                {...(typeof item.renderProps === 'function'
                                                    ? item.renderProps({
                                                          form,
                                                          initialValues
                                                      })
                                                    : {})}
                                                className={classNames(styles.item)}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            )
                        }}
                    </Form.Item>
                )
            })}
        </Row>
    )
}

/**
 * @deprecated
 * 这个组件已经废弃，不要再使用，推荐使用 src/modules/globals/components/QueryFilter 组件。
 */
const QueryFilter = forwardRef(
    (
        {
            name,
            fields = [],
            initialValues = {},
            queryValues = {},
            className,
            classname,
            onValuesChange = () => {},
            onChange = () => {},
            showScan = true,
            showCol = true,
            verticalSize = 'normal',
            num = 4,
            searchType = 'primary',
            noCollapsedFields = [],
            defaultCollapsed = true,
            topNoCollapsedFields = [],
            reset,
            uid,
            memoCollapsed = false,
            clearCheckedFilter = () => {},
            disabled = false,
            hideRest = false,
            configKey = '',
            extraQuery = {},
            onConfigAdd,
            quickFilterLength,
            buttonExtend,
            dynamicSize = false, // 是否根据屏幕动态切换 default small
            storagekeyPrefix = location.pathname, // 如果需要缓存，缓存的key前缀
            hideSearch = false, // 是否显示搜索/重置按钮
            resetFilterItemLayout = filterItemLayout, // 栅格布局
            ...restProps
        },
        ref
    ) => {
        const { size } = useWindowSize({ dynamicSize })
        const fontSize = useMemo(() => {
            return size === 'small' ? '12px' : '14px'
        }, [size])
        const tableNameAndId = `${name}_queryFilter`
        const [collapsed, setCollapsed] = useState(() => {
            if (memoCollapsed) {
                // 只记录 true
                // 没有就 收起
                const arr = storage.get(`${tableNameAndId}_collapsed`) || []
                return arr.indexOf(uid) > -1
            }

            return defaultCollapsed
        })
        const [form] = Form.useForm()

        const search = async () => {
            let values = null

            try {
                values = await form.validateFields()
            } catch (e) {
                console.error('validate', e)
                const { errorFields } = e
                const firstName = errorFields && errorFields[0] && errorFields[0].name
                scrollTo(firstName)
                $message.error('请填写正确搜索内容')
                return Promise.reject(new Error('操作失败'))
            }

            jstLogSearch({
                args: values
            })

            onChange(values, 'search')
        }

        useImperativeHandle(
            ref,
            () => ({
                ...form,
                search,
                handleReset,
                setQuickSearch
            }),
            [form]
        )

        const setQuickSearch = values => {
            form.resetFields()
            form.setFieldsValue(values)
            onChange(values, 'search')
        }

        const handleReset = () => {
            form.resetFields()

            onChange(initialValues, 'reset')
        }

        useEffect(() => {
            if (Object.keys(queryValues).length) {
                form.setFieldsValue({ ...initialValues, ...queryValues })
            }
        }, [queryValues])

        // 回车搜索
        useEffect(() => {
            setTimeout(() => {
                const $el = document.getElementById(tableNameAndId)

                if (!$el) {
                    return
                }

                $el.onkeyup = debounce(event => {
                    const noEnterEvent = !event?.target?.dataset?.keyenterevent
                    if (noEnterEvent && (event.key === 'Enter' || event.code === 'Enter')) {
                        search()
                    }
                }, debounceTimer)
            })
        }, [name, search])

        const setMemoCollapsed = bool => {
            // 只记录 true 收起
            let arr = storage.get(`${tableNameAndId}_collapsed`) || []
            const index = arr.indexOf(uid)
            if (index > -1 && !bool) {
                arr.splice(index, 1)
            }

            if (index === -1 && bool) {
                arr.push(uid)
            }

            storage.set(`${tableNameAndId}_collapsed`, arr)
        }

        // 快捷查询保存
        const showQuickSearchModal = async () => {
            if (quickFilterLength === maxQuickFilterLength) {
                $message.warning(`最多可添加10个快捷查询条件，请您删除不需要的快捷查询条件`)
                return
            }

            const formValues = await form.getFieldsValue()
            const values = {
                ...formValues,
                ...extraQuery
            }

            if (isEmptyObj(values)) {
                $message.warning(`请先填写筛选项`)
                return
            }
            clearCheckedFilter?.()
            createAPI(QuickSearchModal, {
                onOk: selectName =>
                    onConfigAdd({
                        selectName,
                        fields: values
                    })
            })
        }

        const renderButtonExtend = () => {
            if (typeof buttonExtend === 'function') {
                return buttonExtend()
            }
            if (buttonExtend) {
                return buttonExtend
            }
            return null
        }

        return (
            <StyledQueryFilter fontSize={fontSize}>
                <div id={tableNameAndId}>
                    <Form
                        name={name}
                        form={form}
                        scrollToFirstError
                        initialValues={initialValues}
                        className={className}
                        onValuesChange={onValuesChange}
                        size={size}
                        {...restProps}
                    >
                        <div>
                            <div
                                className={classNames(
                                    styles.queryFilter,
                                    {
                                        [styles.normalVerticalSize]: verticalSize === 'normal',
                                        [styles.largeVerticalSize]: verticalSize === 'large'
                                    },
                                    classname
                                )}
                            >
                                {topNoCollapsedFields?.length > 0 &&
                                    renderFields({
                                        fields: topNoCollapsedFields,
                                        name,
                                        num,
                                        form,
                                        initialValues,
                                        showCol,
                                        storagekeyPrefix,
                                        resetFilterItemLayout
                                    })}
                            </div>
                        </div>
                        <div>
                            <div
                                className={classNames(
                                    styles.queryFilter,
                                    {
                                        [styles.normalVerticalSize]: verticalSize === 'normal',
                                        [styles.largeVerticalSize]: verticalSize === 'large'
                                    },
                                    classname
                                )}
                            >
                                <div className={classNames(styles.filter, { [styles.filterWidth]: !hideSearch })}>
                                    <div
                                        className={classNames({
                                            [styles.filterCollapsed]: showScan ? collapsed : false,
                                            [styles.smallSize]: size === 'small'
                                        })}
                                    >
                                        {renderFields({
                                            fields,
                                            name,
                                            num,
                                            form,
                                            initialValues,
                                            showCol,
                                            storagekeyPrefix,
                                            resetFilterItemLayout
                                        })}
                                    </div>
                                </div>
                                {!hideSearch ? (
                                    <div
                                        className={classNames({
                                            [styles.operation]: true,
                                            [styles.showScan]: showScan,
                                            [styles.hideRest]: hideRest,
                                            [styles.smallSize]: size === 'small'
                                        })}
                                    >
                                        <div className={styles.space}>
                                            {showScan ? (
                                                <Button
                                                    type="link"
                                                    className={classNames(styles.collapsed, {
                                                        [styles.smallSize]: size === 'small'
                                                    })}
                                                    onClick={() => {
                                                        if (memoCollapsed) {
                                                            setMemoCollapsed(!collapsed)
                                                        }
                                                        setCollapsed(!collapsed)
                                                    }}
                                                >
                                                    {collapsed ? (
                                                        <>
                                                            展开&nbsp;
                                                            <DownOutlined />
                                                        </>
                                                    ) : (
                                                        <>
                                                            收起&nbsp;
                                                            <UpOutlined />
                                                        </>
                                                    )}
                                                </Button>
                                            ) : null}
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div className={styles.operateBtnsWrap}>
                                                    <Button
                                                        className={styles.btn}
                                                        type={searchType}
                                                        onClick={search}
                                                        disabled={disabled}
                                                    >
                                                        搜索
                                                    </Button>
                                                    {!hideRest && (
                                                        <>
                                                            <div className={styles.placeholder} />
                                                            <Button
                                                                className={styles.btn}
                                                                onClick={() => {
                                                                    clearCheckedFilter?.()
                                                                    reset ? reset(form) : handleReset()
                                                                }}
                                                                disabled={disabled}
                                                            >
                                                                重置
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>

                                                {configKey && (
                                                    <Button
                                                        className={styles.quickSearch}
                                                        onClick={showQuickSearchModal}
                                                    >
                                                        另存为快捷查询
                                                    </Button>
                                                )}
                                            </div>
                                        </div>

                                        {renderButtonExtend()}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div
                            className={classNames(
                                styles.queryFilter,
                                {
                                    [styles.normalVerticalSize]: verticalSize === 'normal',
                                    [styles.largeVerticalSize]: verticalSize === 'large'
                                },
                                classname
                            )}
                        >
                            {noCollapsedFields?.length > 0 &&
                                renderFields({
                                    fields: noCollapsedFields,
                                    name,
                                    num,
                                    form,
                                    initialValues,
                                    showCol,
                                    storagekeyPrefix,
                                    resetFilterItemLayout
                                })}
                        </div>
                    </Form>
                </div>
            </StyledQueryFilter>
        )
    }
)

// 产品需求部分放开
// QUICK_SEARCH 以QS 开头
const WHITE_LIST = ['']

export const QuickSearchQueryFilterInner = forwardRef((props, ref) => {
    const { configKey, config, setConfig, onClickQuickFilterCb, ...restProps } = props
    const [checkedFilter, setCheckedFilter] = useState()
    const $queryFilterRef = useRef(null)

    useImperativeHandle(ref, () => ({ ...($queryFilterRef?.current || {}) }), [])

    //  暂时没有要求，代码我先留在这里，有需要再加
    // eslint-disable-next-line no-unused-vars
    const hasQuickSearchSetting = WHITE_LIST.includes(configKey)

    const { filters = [], ...restConfigs } = config || {}

    const onUpdateConfig = newFilter => {
        setConfig(configKey, { ...restConfigs, filters: newFilter })
    }

    const clearCheckedFilter = () => {
        setCheckedFilter(null)
    }

    const handelConfigAdd = ({ selectName, fields }) => {
        onUpdateConfig([{ selectName, fields }, ...filters])
    }

    const handelDel = index => {
        const newFilter = [...filters]
        newFilter.splice(index, 1)
        // 返回值是删除的那个
        onUpdateConfig(newFilter)
    }

    const handelClickFilter = (item, index) => {
        setCheckedFilter(`${item.selectName}-${index}`)
        $queryFilterRef?.current?.setQuickSearch(item.fields)
        onClickQuickFilterCb?.(item, index)
    }

    return (
        <div>
            <QueryFilter
                {...restProps}
                clearCheckedFilter={clearCheckedFilter}
                configKey={configKey}
                quickFilterLength={filters?.length}
                ref={$queryFilterRef}
                onConfigAdd={handelConfigAdd}
            />
            <Space
                size="small"
                style={{
                    marginTop: 2
                }}
                wrap
            >
                {filters?.length > 0 && <div className={styles.searchTitle}>快捷查询：</div>}
                {filters.map((item, index) => {
                    const checked = checkedFilter === `${item.selectName}-${index}`
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className={styles.container} key={`${item.selectName}-${index}`}>
                            <Button
                                type="link"
                                className={checked ? styles.checked : styles.noChecked}
                                onClick={() => handelClickFilter(item, index)}
                            >
                                <span>{item.selectName}</span>
                            </Button>
                            {!checked && (
                                <Popconfirm
                                    title={<div style={{ width: 100 }}>是否删除?</div>}
                                    okText="是"
                                    cancelText="否"
                                    onConfirm={() => {
                                        handelDel(index)
                                    }}
                                >
                                    <div className={styles.close}>
                                        <CloseCircleFilled />
                                    </div>
                                </Popconfirm>
                            )}
                        </div>
                    )
                })}
            </Space>
            {filters?.length > 0 && <div className={styles.border} />}
        </div>
    )
})

const DEFAULT_CONFIG = {}

const mapStateToProps = ({ user: { config } }, ownProps) => {
    return {
        config: (config && ownProps.configKey && config[ownProps.configKey]) || DEFAULT_CONFIG
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setConfig(configKey, configValue) {
            dispatch({
                type: 'user/addConfig',
                payload: {
                    configKey,
                    configValue
                }
            })
        }
    }
}

export const QuickSearchQueryFilter = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    QuickSearchQueryFilterInner
)

export default QueryFilter
